import { render, staticRenderFns } from "./packageAddMore.vue?vue&type=template&id=2194ca6c&scoped=true"
import script from "./packageAddMore.vue?vue&type=script&lang=js"
export * from "./packageAddMore.vue?vue&type=script&lang=js"
import style0 from "./packageAddMore.vue?vue&type=style&index=0&id=2194ca6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2194ca6c",
  null
  
)

export default component.exports